import React from 'react';
import styles from './Header.module.css';

const VipButton = ({ isVip, onClick }) => {
  return (
    <div className={styles.menuItem}>
      <button 
        // Класс iconButton всегда применяется, а класс active добавляется, если isVip равен true
        className={`${styles.iconButton} ${isVip ? styles.active : ''}`}
        onClick={onClick} // При клике вызывается функция onVipClick
        aria-label="VIP" // Атрибут для доступности
      >
		{/* SVG-иконка короны для обозначения VIP статуса */}
		<svg className={styles.icon} viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
		  <path d="M2 19h20v2H2v-2zM2 5l5 3.5L12 2l5 6.5L22 5v12H2V5zm2 3.841V15h16V8.841l-3.42 2.394L12 5.28l-4.58 5.955L4 8.84z"/>
		</svg>
      </button>
    </div>
  );
};

export default VipButton;
